__turbopack_context__.v({
  "badge": "badge-module-scss-module__yyFPZG__badge",
  "medium": "badge-module-scss-module__yyFPZG__medium",
});
